import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M5.333 7.014C7.017 5.61 9.263 4.4 12 4.4c2.738 0 4.984 1.21 6.667 2.614 1.682 1.404 2.84 3.033 3.42 3.952.008.01.014.021.02.032.12.19.24.377.3.644a1.76 1.76 0 0 1 0 .715c-.06.268-.18.456-.3.645l-.02.031c-.58.92-1.738 2.548-3.42 3.952C16.984 18.391 14.738 19.6 12 19.6s-4.983-1.21-6.667-2.615c-1.682-1.404-2.84-3.032-3.42-3.951l-.02-.032c-.12-.19-.239-.377-.3-.645a1.763 1.763 0 0 1 0-.715c.061-.267.18-.455.3-.644l.02-.032c.58-.92 1.738-2.548 3.42-3.952ZM12 9.6a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8ZM8.4 12a3.6 3.6 0 1 1 7.2 0 3.6 3.6 0 0 1-7.2 0Z"
      clip-rule="evenodd"
    />
  </svg>
`;
